module.exports = __webpack_public_path__ + "img/fxh.9a71ce76.png";